module.exports = __webpack_public_path__ + "static/media/lucienEtMonstre.77c23ae4.png";